module.exports = __webpack_public_path__ + "img/服务.1f3d126a.svg";